import { createFileRoute } from '@tanstack/react-router';

/**
 * Originação — conteúdo idêntico ao antigo /originacao, só reparentada sob o módulo Pipeline.
 * Componente vem de pipeline.originacao.lazy.tsx (code-splitting por rota, D4/DEC-060).
 */
export const Route = createFileRoute('/pipeline/originacao')({});
